import { UnifiedMandateStatus } from '@cp/src/reducers/commonSlice';

export enum ENACHStatus {
  Failed = 'Autopay Failed',
  AutopayInProgress = 'Autopay in progress',
  AutopayNotSetup = 'Autopay has not been setup',
  AutopaySetup = 'Autopay has been setup',
  AutopayRevoked = 'Autopay is revoked',
  AutopayExpired = 'Autopay is expired'
}
export const enachRevokedStatuses = [
  UnifiedMandateStatus.MANDATE_REVOKED,
  UnifiedMandateStatus.REVOKED
];

export const enachExpiredStatuses = [UnifiedMandateStatus.MANDATE_EXPIRED];
export const enachSetupStatuses = [UnifiedMandateStatus.SUCCESS];

export const enachNotSetupStatuses = [
  UnifiedMandateStatus.INITIATED,
  UnifiedMandateStatus.FORM_CREATION_FAILED,
  UnifiedMandateStatus.FORM_CREATED,
  UnifiedMandateStatus.SIGNED,
  UnifiedMandateStatus.SIGN_FAILURE,
  UnifiedMandateStatus.FAILURE,
  UnifiedMandateStatus.FAILED,
  UnifiedMandateStatus.DISABLED
];
